import React from 'react';
import './Sections.scss';

function Section1() {
  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        The pandemic has made people rethink what they want and need from their homes. Confined to
        their homes for long stretches of time as travel shut down and even dining out became a
        fraught experience, home buyers decided that they needed more space. In 2022, buyers
        continued the trend of moving to small towns and rural areas, both for reasons of
        affordability and to be closer to family and friends. Those are some of the big takeaways
        from the{' '}
        <a
          className="hyperLink"
          href="https://cdn.nar.realtor/sites/default/files/documents/2022-highlights-from-the-profile-of-home-buyers-and-sellers-report-11-03-2022_0.pdf"
          target="_blank"
          rel="sponsored"
        >
          2022 Profile of Home Buyers and Sellers
        </a>
        , a report produced annually by the National Association of REALTORS® (NAR) based on survey
        data from 6,000 respondents in every U.S. state.
      </p>
      <p className="sections-copy">
        “People who ended up working from home decided they needed a home office – or possibly even
        two home offices if multiple people in the household have been engaging in remote work,”
        says{' '}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/jessica-lautz"
          target="_blank"
           rel="sponsored"
        >
          Dr. Jessica Lautz, Deputy Chief Economist and Vice President of Research at NAR
        </a>
        . “Since buyers are cooking at home instead of eating out, they want a bigger kitchen and
        perhaps some land to grow vegetables in their backyard. Their priorities have really
        changed.”
      </p>
    </section>
  );
}

export default Section1;
